const processStringPrice = (input: string): string => {
  // Check if the input string matches the specific patterns
  if (input === "$0 - $0") {
    return "Sold Out";
  } else if (input === "$1 - $1") {
    return "Unreleased";
  } else {
    // Check for the pattern "$0 - $abc" or similar and return the second part
    const match = input?.match(
      /^\$\d\s*-\s*(\$\d{1,3}(?:,\d{3})*(?:\.\d{1,3})?)/
    );
    if (match) {
      return match[1];
    }
  }
  return input; // Return the original string if it doesn't match any pattern
};

export default processStringPrice;
